import firebase from "firebase";
import { db, auth } from "../../Firebase/firebase";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import router from "../../router/index";
import { Date } from "core-js";
import Vue from "vue";
import { baseurl } from "../../helpers/helper";

const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);

export default {
  namespaced: true,
  state: {
    items: [],
    Items: [],
  },

  mutations: {
    SET_ITEMSS(state, data) {
      state.Items = data;
    },
  },

  actions: {
    async createItem({ commit, dispatch }, { file, userId, form }) {
      const urlArray = await dispatch("getUrlArray", file, { root: true });
      db.collection("Items")
        .doc(userId)
        .collection("userItems")
        .add({
          ...form,
          img: urlArray,
          createdAt: new Date(),
          is_active: true,
          ownerId: auth.currentUser.uid,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully created item",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data, { root: true });
          /* dispatch("changeMenuItemsCount", { action: "increase", menuId });
          dispatch("fetchItems", { menuId, category }); */
        });
    },

    async editItem({ commit, dispatch }, { form, images, itemId, file }) {
      const urlArray = await dispatch("getUrlArray", file, { root: true });
      const newUrlArray = [...new Set([...images, ...urlArray])];
      db.collection("Items")
        .doc(auth.currentUser.uid)
        .collection("userItems")
        .doc(itemId)
        .update({
          ...form,
          img: newUrlArray,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully updated item",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data, { root: true });
        });
    },

    async deleteItem({ commit, dispatch }, itemId ) {
      db.collection("Items")
        .doc(auth.currentUser.uid)
        .collection("userItems")
        .doc(itemId)
        .update({
          is_active: false,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully deleted menu item",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data,{root:true});
        });
    },

    fetchItems: firestoreAction(
      (
        { commit, dispatch, state, bindFirestoreRef },
        { userId, limit, query }
      ) => {
        bindFirestoreRef(
          "items",
          db
            .collection("Items")
            .doc(userId)
            .collection("userItems")
            .where("name", ">=", query)
            .where("name", "<=", query + "\uf8ff")
            .where("is_active", "==", true)
            .orderBy("name", "desc")
            .limit(limit)
        );
      }
    ),
    async fetchItemss({ commit, dispatch }, { userId, limit, query }) {
      let itemsArray = [];
      const response = await db
        .collection("Items")
        .doc(userId)
        .collection("userItems")
        .where("name", ">=", query)
        .where("name", "<=", query + "\uf8ff")
        .where("is_active", "==", true)
        .orderBy("name", "desc")
        .limit(limit)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            post.id = doc.id;

            itemsArray.push(post);
          });
        });

      return itemsArray;
    },
  },
};
